import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import ManualCropProtectionInputsConnected from '../planting-plan-form/CropProtection/ManualCropProtectionInputs';

const baseString = 'vra-script-config-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
const titleClassString = classNames({
  [`${baseString}__header`]: true,
  'vra-script-config-inputs__header': true
});
export const ScriptConfigProtectionInputs = ({
  displayScriptName,
  maxDate,
  minDate,
  onChangeScriptName,
  onSelectIncorporationMethod,
  plantingPlanParams,
  validationResult
}) => {
  return (
    <section className={classString}>
      <header className={titleClassString}>{getMessage('title-text__script-config')}</header>
      <ManualCropProtectionInputsConnected 
        displayScriptName={displayScriptName}
        maxDate={maxDate}
        minDate={minDate}
        onChangeScriptName={onChangeScriptName}
        onSelectIncorporationMethod={onSelectIncorporationMethod}
        plantingPlanParams={plantingPlanParams}
        validationResult={validationResult}
      />
    </section>
  );
};

ScriptConfigProtectionInputs.propTypes = {
  displayScriptName: propTypes.string,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onChangeScriptName: propTypes.func.isRequired,
  onSelectIncorporationMethod: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  validationResult: propTypes.object
};
